module.exports = __webpack_public_path__ + "img/1.c1814be8.png";